<template>
  <div class="container p-5">
    <div class="pt-5">
      <h5 class="font-weight-light">
        <b>Novo Registro</b>
      </h5>
      <p class="mt-1 text-left text-muted">
        Preencha os dados do cliente para criar um novo registro.
      </p>
    </div>
    <hr class="mt-1" />

    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(criarRegistro)">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Nome completo</label>
              <ValidationProvider
                name="Nome"
                rules="required|min:3"
                v-slot="{ errors, classes }"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="form.nome"
                  :class="classes"
                  placeholder="Ex: João da Silva"
                />
                <span class="invalid-feedback">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>E-mail</label>
              <ValidationProvider
                name="E-mail"
                rules="required|email"
                v-slot="{ errors, classes }"
              >
                <input
                  type="email"
                  class="form-control"
                  v-model="form.email"
                  :class="classes"
                  placeholder="Ex: joao@email.com"
                />
                <span class="invalid-feedback">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>CPF</label>
              <ValidationProvider
                name="CPF"
                rules="required|cpf"
                v-slot="{ errors, classes }"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="form.cpf"
                  :class="classes"
                  v-mask="'###.###.###-##'"
                  placeholder="000.000.000-00"
                />
                <span class="invalid-feedback">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Telefone</label>
              <ValidationProvider
                name="Telefone"
                rules="required"
                v-slot="{ errors, classes }"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="form.telefone"
                  :class="classes"
                  v-mask="'(##) #####-####'"
                  placeholder="(11) 98765-4321"
                />
                <span class="invalid-feedback">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Data de nascimento</label>
              <ValidationProvider
                name="Data de nascimento"
                rules="required"
                v-slot="{ errors, classes }"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="form.nascimento"
                  :class="classes"
                  v-mask="'##/##/####'"
                  placeholder="00/00/0000"
                />
                <span class="invalid-feedback">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>UF</label>
              <ValidationProvider
                name="UF"
                rules="required"
                v-slot="{ errors, classes }"
              >
                <select
                  class="form-control"
                  v-model="form.uf"
                  :class="classes"
                >
                  <option value="" disabled>Selecione o estado</option>
                  <option v-for="estado in estados" :key="estado.sigla" :value="estado.sigla">{{ estado.nome }}</option>
                </select>
                <span class="invalid-feedback">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>

        <div class="mt-2 d-flex justify-content-end">
          <b-button
            type="submit"
            variant="success"
            :disabled="loading"
            class="px-4"
          >
            <span v-if="loading">
              <b-spinner small class="mr-2" />
              Cadastrando...
            </span>
            <span v-else>Cadastrar registro</span>
          </b-button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import config from "../../config";
import captureError from "../../helpers/captureError";
import removerMascaraTelefone from "../../helpers/removerMascaraTelefone";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      loading: false,
      form: {
        nome: "",
        email: "",
        cpf: "",
        telefone: "",
        nascimento: "",
        uf: "",
      },
      estados: [
        { sigla: "AC", nome: "Acre" },
        { sigla: "AL", nome: "Alagoas" },
        { sigla: "AP", nome: "Amapá" },
        { sigla: "AM", nome: "Amazonas" },
        { sigla: "BA", nome: "Bahia" },
        { sigla: "CE", nome: "Ceará" },
        { sigla: "DF", nome: "Distrito Federal" },
        { sigla: "ES", nome: "Espírito Santo" },
        { sigla: "GO", nome: "Goiás" },
        { sigla: "MA", nome: "Maranhão" },
        { sigla: "MT", nome: "Mato Grosso" },
        { sigla: "MS", nome: "Mato Grosso do Sul" },
        { sigla: "MG", nome: "Minas Gerais" },
        { sigla: "PA", nome: "Pará" },
        { sigla: "PB", nome: "Paraíba" },
        { sigla: "PR", nome: "Paraná" },
        { sigla: "PE", nome: "Pernambuco" },
        { sigla: "PI", nome: "Piauí" },
        { sigla: "RJ", nome: "Rio de Janeiro" },
        { sigla: "RN", nome: "Rio Grande do Norte" },
        { sigla: "RS", nome: "Rio Grande do Sul" },
        { sigla: "RO", nome: "Rondônia" },
        { sigla: "RR", nome: "Roraima" },
        { sigla: "SC", nome: "Santa Catarina" },
        { sigla: "SP", nome: "São Paulo" },
        { sigla: "SE", nome: "Sergipe" },
        { sigla: "TO", nome: "Tocantins" },
      ],
    };
  },
  methods: {
    async criarRegistro() {
      this.loading = true;
      try {
        const payload = {
          nome: this.form.nome,
          email: this.form.email,
          cpf: this.form.cpf.replace(/\D/g, ""),
          telefone: removerMascaraTelefone(this.form.telefone),
          nascimento: new Date(this.form.nascimento.split('/').reverse().join('-')).toISOString(),
          uf: this.form.uf,
          origem: this.$route.name,
        };

        const response = await axios.post(
          `${config.API_URLV2}/cliente/criar-ou-atualizar`,
          payload
        );

        this.$router.push({
          name: "planos-registro",
          params: { clienteId: response.data.id, clienteNome: this.form.nome },
        });
      } catch (error) {
        captureError(error);
        const erros = error.response && error.response.data && error.response.data.erros;
        const mensagem = erros && erros.length > 0
          ? erros[0]
          : error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Não foi possível concluir o cadastro. Tente novamente.";
        Swal.fire({
          title: "Ops!",
          text: mensagem,
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#d33",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
